module.exports = __webpack_public_path__ + "static/media/anime-wow.2bd688cf.mp3";